const validateZipCode = (event: any): any => {
  const pattern = /^[0-9]+$/;
  if (pattern.test(event.target.value)) {
    return event.target.value.toString().slice(0, 5);
  } else {
    return '';
  }
};
export default validateZipCode;
